exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.vue-book-input {\n  border-radius: 3px;\n  border: 1px solid #1fc8db;\n  padding: 4px 5px;\n  width: 100%;\n}\n.vue-book-input:focus::placeholder {\n    opacity: 0;\n}\n", ""]);

// exports
